import { parseJson, touch } from 'helpers/transforms'

export const toMetadata = function (data) {
  const content = parseJson(data)
  const files = {}
  const parents = {}
  content.filter(({ automated }) => !automated).forEach(({ id, name, lastUpdateTime, properties, tiers }) => {
    files[id] = Object.assign(
      {
        id,
        name,
        lastUpdateTime,
        tiers,
        position:
          parseFloat(properties.position) === 0
            ? parseFloat(properties.position)
            : parseFloat(properties.position) || null
      },
      properties
    )
    touch(parents, [properties.parentId || properties.section], []).push(id)
  })
  return { files, parents }
}

export const toMetadataSearch = function (data) {
  data = parseJson(data)
  return {
    resultCount: data.count || 0,
    results: data.results
      ? data.results.map(
        ({
          id,
          name,
          properties: { title, description, parentId, library, position },
          tiers
        }) => ({
          id,
          name: name || null,
          title: title || null,
          description: description || '',
          parentId: parentId || null,
          library: library || null,
          position: position || null,
          tiers: tiers || null
        })
      )
      : [],
    flatFacets: data.facets || []
  }
}

export const toClarilisLink = (json) => {
  const { link, text } = parseJson(json)

  return { url: link, text }
}

export const toClarilisDocs = (json) => {
  const links = parseJson(json)

  return links.map(({
    actionLink,
    marketingLink,
    updated: recentlyUpdated,
    title
  }) => ({
    actionLink,
    marketingLink,
    recentlyUpdated,
    title
  }))
}

export const toDocDrafterListings = (json) => {
  const docs = parseJson(json)

  const parents = docs.reduce((set, { data: { parentSectionId, id } }) => {
    if (!set[parentSectionId]) {
      set[parentSectionId] = []
    }
    set[parentSectionId].push(id)

    return set
  }, {})

  const documents = docs.map(({
    hasAccess,
    data: {
      id,
      uuid,
      title,
      description,
      parentSectionId: parentId
    }
  }) => ({
    id,
    uuid,
    title,
    description,
    parentId,
    hasAccess
  })
  )

  return { documents, parents }
}

export const transformPreview = (data) => {
  const { fileData } = parseJson(data)
  return {
    preview: Buffer.from(fileData, 'base64').toString() // better practice than atob though is the same
  }
}

export const toPreviewList = (data) => {
  data = parseJson(data)
  return data.map(({ fileId, path, name }) => ({ fileId, path, name }))
}

export const toDownloadedInterview = (json) => {
  const [data] = JSON.parse(json)
  const byteCharacters = [...Buffer.from(data.fileData, 'base64').toString('binary')]
  const byteNumbers = byteCharacters.map((char) => char.charCodeAt(0))
  const bytes = new Uint8Array(byteNumbers)

  return {
    fileData: new Blob([bytes], { type: data.mimetype }),
    fileName: data.fileName
  }
}
